import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('../app/app.routes').then((m) => m.routes(1)),
  },
  {
    path: '**',
    redirectTo: '/',
    pathMatch: 'full',
  },
];
